module.exports = __webpack_public_path__ + "img/close-white.8115abe4.svg";